import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=292d8e19&scoped=true"
import script from "./PromotionDetails.vue?vue&type=script&lang=js"
export * from "./PromotionDetails.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetails.vue?vue&type=style&index=0&id=292d8e19&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d8e19",
  null
  
)

export default component.exports